import axios from "axios";

export const POST_PAYMENT_SUCCESS = "POST_PAYMENT_SUCCESS";
export const POST_PAYMENT_FAILURE = "POST_PAYMENT_FAILURE";
export const POST_PAYMENT_STARTED = "POST_PAYMENT_STARTED";

export const postPayment = (paymentData) => {
  return (dispatch) => {
    dispatch(postPaymentStarted());

    axios
      .post("/contracts/make-payment/", paymentData)
      .then(({ data }) => {
        dispatch(postPaymentSuccess(data));
      })
      .catch((err) => {
        dispatch(
          postPaymentFailure(
            `${err.response.data.ui_message} Card has not been charged.`
          )
        );
      });
  };
};

const postPaymentStarted = () => ({ type: POST_PAYMENT_STARTED });
const postPaymentFailure = (error) => ({
  type: POST_PAYMENT_FAILURE,
  payload: error,
});

const postPaymentSuccess = (paymentInfo) => ({
  type: POST_PAYMENT_SUCCESS,
  payload: paymentInfo,
});

function paymentReducer(state, action) {
  switch (action.type) {
    case POST_PAYMENT_STARTED:
      return {
        ...state,
        loading: true,
      };
    case POST_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case POST_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        payment: action.payload,
        paymentSkipped: false,
        paymentTransactions: [...state.paymentTransactions, action.payload],
      };
    default:
      return state;
  }

  return state;
}

export default paymentReducer;
